// Use this controller for array value form inputs where we can reuse the same input multiple times. This is used for
// specifying an NiTableAttribute's enum values where we render a single text_field for each enum_value that exists.

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['template', 'container']

  remove (event) {
    event.preventDefault()
    const wrapper = event.target.closest('.input-wrapper')
    wrapper.remove()
  }

  add (event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML
    this.containerTarget.insertAdjacentHTML('beforeend', content)
  }
}
